export interface ApiAdvQueueEmailReport {
  EmailReportId: string;
  AdvQueueId: string;
  ObjectId: string;
  ObjectClass: string;
  ToAddress: string;
  ToName: string;
  Frequency: string;
}

export interface AdvQueueEmailReport {
  emailReportId: string;
  advQueueId: string;
  objectId: string;
  objectClass: string;
  toAddress: string;
  toName: string;
  frequency: string;
}

export function apiAdvQueueEmailReportToAdvQueueEmailReport(
  apiAdvQueueEmailReport: ApiAdvQueueEmailReport
): AdvQueueEmailReport {
  return {
    emailReportId: apiAdvQueueEmailReport.EmailReportId,
    advQueueId: apiAdvQueueEmailReport.AdvQueueId,
    objectId: apiAdvQueueEmailReport.ObjectId,
    objectClass: apiAdvQueueEmailReport.ObjectClass,
    toAddress: apiAdvQueueEmailReport.ToAddress,
    toName: apiAdvQueueEmailReport.ToName,
    frequency: apiAdvQueueEmailReport.Frequency
  };
}
